var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.type === 1)?_c('InquirePage',{on:{"search":_vm.search}}):_vm._e(),(_vm.type === 2)?_c('ListPage',{attrs:{"order":_vm.orderText,"infoList":_vm.infoList},on:{"search":_vm.search}}):_vm._e(),(_vm.type === 3)?_c('EmptyPage',{attrs:{"order":_vm.orderText},on:{"backHome":_vm.backHome,"search":_vm.search}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }